import { takeLatest, put, call } from 'redux-saga/effects';
import { history } from '@commons';
import { createEstagioAplicacaoCadastro, updateEstagioAplicacaoCadastro } from '../service';
import {
  CREATE_ESTAGIO_APLICACAO_CADASTRO,
  CREATE_ESTAGIO_APLICACAO_CADASTRO_PENDING,
  CREATE_ESTAGIO_APLICACAO_CADASTRO_SUCCESS,
  CREATE_ESTAGIO_APLICACAO_CADASTRO_FAILURE,
  CONFIG_SESSION
} from '@handler';
import { AlertSuccess, AlertError } from '@components/common/AlertToast';
import { trackingEventCX, MODULE_ACTIONS_ENUM } from '@handler/tracking/customerX';

function* sagaCreateEstagioAplicacaoCadastro(action) {
  yield put({ type: CREATE_ESTAGIO_APLICACAO_CADASTRO_PENDING });

  try {
    if (action.data.id === undefined || action.data.id === null) {
      yield call(createEstagioAplicacaoCadastro, action.data);
      trackingEventCX('action', MODULE_ACTIONS_ENUM.ESTAGIO_APLICACAO_CRIAR);
    } else {
      yield call(updateEstagioAplicacaoCadastro,
        {
          ...action.data,
          id: action.data.id
        }
      );
      trackingEventCX('action', MODULE_ACTIONS_ENUM.ESTAGIO_APLICACAO_EDITAR);
    }

    yield put({ type: CREATE_ESTAGIO_APLICACAO_CADASTRO_SUCCESS, registro: action.data });

    if(!action.isCadastroRapido){
      history.push('/agricultura/aplicacao/estagio');
    }

    AlertSuccess('Registro salvo com sucesso!');
  } catch (error) {
    yield put({ type: CREATE_ESTAGIO_APLICACAO_CADASTRO_FAILURE, registro: action.data });
    AlertError('Falha ao salvar o registro! Tente novamente...');
  }
}

export default function* watchCreateEstagioAplicacaoCadastro() {
  yield takeLatest(CREATE_ESTAGIO_APLICACAO_CADASTRO, sagaCreateEstagioAplicacaoCadastro);
}
